import { render, staticRenderFns } from "./CaseHistoryTemplate.vue?vue&type=template&id=16a9d36b&scoped=true"
import script from "./CaseHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./CaseHistoryTemplate.vue?vue&type=script&lang=js"
import style0 from "./CaseHistoryTemplate.vue?vue&type=style&index=0&id=16a9d36b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9d36b",
  null
  
)

export default component.exports